module.exports = __webpack_public_path__ + "img/tinder.c4fc7af3.svg";